import React from 'react';
import { Router } from 'modules'

export const App = () => {
  return (
    <Router />
  );
};
